module.exports = __webpack_public_path__ + "static/img/logo-img-two.e6ef84e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-img-two.png
// module id = YE5L
// module chunks = 1